import useTourists from "@/hooks/tourists/index.js";

export default function useMessageManange() {
    const {getTouristsId} = useTourists()

    const formatMsg = async (msgData) => {
        const {text, id} = msgData
        const messageType = msgData.messageType || 0

        // 文本消息
        if (messageType === 0) {
            const {senderId} = msgData
            return {
                ...msgData,
                isRead: false,
                isMe: String(senderId) === String(await getTouristsId()),
                type: 'text',
                value: text
            }
        }

        // 组合消息
        if (messageType === 6) {
            const {
                results,
                type
            } = JSON.parse(text)

            switch (type) {
                // 机器人问题
                case 1:
                    return {id, type: "robot", text: results}
                // 机器人问题 - 对应答案
                case 2:
                    const {reply_content} = results
                    return {
                        id,
                        type: "text",
                        value: reply_content,
                        // value: "答案:" + reply_content,
                        isMe: false,
                        isRead: false
                    }
                //    留言
                case 3:
                    return {
                        id,
                        type: "levelMsg",
                        value: results.content,
                        isMe: false,
                        isRead: false
                    }
                //    留言表单信息
                case 4:
                    return {
                        id,
                        type: "levelMsgInfo",
                        value: results,
                        isMe: false,
                        isRead: false
                    }
                default:
                    return {
                        id,
                        type: "text",
                        value: "[无法显示]",
                        isMe: true,
                        isRead: false
                    }
            }
        }
    }

    return {
        formatMsg
    }
}
